import type { AppNotification } from './types'

/**
 * Prefer role-safe destinations. Stored actionUrl may be stale (e.g. /waitlist/doctors
 * for a nurse). Intake/encounter waiting flows go through /waitlist which redirects
 * by sidebar permission.
 */
export const resolveActionUrl = (item: AppNotification): string | null | undefined => {
  if (item.category === 'intake' || item.category === 'encounter') {
    return '/waitlist'
  }
  return item.actionUrl
}
